import dayjs from 'dayjs';
import IStockLevel from "@/models/responses/IStockLevel";

export async function printZpl(ip: string, zpl: string) {
  const url = "https://" + ip + "/pstprnt";

  fetch(url, {
    mode:  'no-cors',
    method: 'POST',
    body: zpl
  })
  .catch(() => {
    // workaround for CORS issues and somehow sanely printing on a Zebra printer...
  });
}

export async function prepareItemLabelZpl(
  zplTemplate: string,
  itemName: string,
  gtin: string | undefined,
  itemCode: string,
  quantity: number | undefined,
  lot: string | undefined,
  bestBefore: string | undefined,
  expiry: string | undefined,
  stockLevel: IStockLevel | undefined,
  imageRetrievalCallback: (imageTypeCode: string, length: number, width: number) => Promise<string | undefined>) {

  const regexp = /{(\w+).?([\w]*).?([\d]*).?([\d]*)}/g;
  const matches = zplTemplate.matchAll(regexp);

  for (const match of matches) {
    let replacement : any = '';
    switch (match[1]) {
      case 'itemName':
        replacement = itemName;
        break;
      case 'gtin':
        replacement = gtin;
        break;
      case 'itemCode':
        replacement = itemCode;
        break;
      case 'quantity':
        replacement = quantity;
        break;
      case 'lot':
        replacement = lot;
        break;
      case 'bestBefore':
        replacement = bestBefore;
        break;
      case 'expiry':
        replacement = expiry;
        break;
      case 'minQuantity':
        replacement = stockLevel?.minQuantity ?? 0;
        break;
      case 'maxQuantity':
        replacement = stockLevel?.maxQuantity ?? 0;
        break;
      case 'dm128':
        replacement = getDataMatrixEan128(gtin, itemCode, quantity, lot, bestBefore, expiry);
        break;
      case 'img':
        replacement = await imageRetrievalCallback(
          match.length > 2 ? match[2]! : 'main',
          match.length > 3 && !isNaN(Number(match[3])) ? Number(match[3]) : 200,
          match.length > 4 && !isNaN(Number(match[4])) ? Number(match[4]) : 140);
        break;
    }

    zplTemplate = zplTemplate.replace(match[0], replacement);
  }
  
  return zplTemplate;
}

export function getDataMatrixEan128(gtin: string | undefined, itemCode: string, quantity: number | undefined, lot: string | undefined, bestBefore: string | undefined, expiry: string | undefined): string {
  let ean128 = '';
  
  if (gtin) {
    ean128 = `${ean128}_101${gtin}`;
  } else {
    ean128 = `${ean128}_191${itemCode}`;
  }
  if (quantity) {
    ean128 = `${ean128}_137${quantity}`;
  }
  if (lot) {
    ean128 = `${ean128}_110${lot}`;
  }
  if (bestBefore) {
    const bestBeforeFormatted = dayjs(bestBefore).format('YYMMDD');
    ean128 = `${ean128}_15${bestBeforeFormatted}`;
  }
  if (expiry) {
    const expiryFormatted = dayjs(expiry).format('YYMMDD');
    ean128 = `${ean128}_117${expiryFormatted}`;
  }
  
  return ean128;
}